import React from 'react'
import { createContext, useState, useEffect, useRef } from "react";
import axios from "axios"
import AuthContext from "./AuthContext";
import StatusContext from "./StatusContext";
import ClientContext from "./ClientContext";

import { emailproperty, performancereview, inventory, extraction, problemsolving, productdescription, floridaoranges, email, travelexpense} from "../data/TemplateSamples.ts"
import {floridaoranges_Serbian, performancereview_Serbian, email_Serbian, travelexpense_Serbian} from "../data/TemplateSamples_Serbian.ts"
import {floridaoranges_Spanish, performancereview_Spanish, email_Spanish, travelexpense_Spanish} from "../data/TemplateSamples_Spanish.ts"
import {floridaoranges_Portuguese, performancereview_Portuguese, email_Portuguese, travelexpense_Portuguese} from "../data/TemplateSamples_Portuguese.ts"
import {floridaoranges_French, performancereview_French, email_French, travelexpense_French} from "../data/TemplateSamples_French.ts"
import {floridaoranges_German, performancereview_German, email_German, travelexpense_German} from "../data/TemplateSamples_German.ts"
import { config } from '../config';

const CustomTemplatesContext = createContext();

export default CustomTemplatesContext;

export const CustomTemplatesProvider = ((props) => {
    const promptareaRef = useRef(null)
    const [templateName, setTemplateName] = useState('');
    const [chatNames, setChatNames] = useState([])
    const [chatName, setChatName] = useState('');
    const [templates, setTemplates] = useState([]);
   
    const [prompts, setPrompts] = useState([]);
    const [prompt, setPrompt] = useState('')
    const [promptedit, setPromptEdit] = useState(false)
    const [samples, setSamples] = useState([])
    const [status, setStatus] = useState();
    const [showAddPrompt, setShowAddPrompt] = useState(false);
    const [promptsAvailable, setPromptsAvailable] = useState(false);
    

    const[allresponses, setAllResponses] = useState([])
    const[newPrompt, setNewPrompt] = useState({
        id: 0,
        who: '',
        what: '',
    })

    const[showNewPromptDialog, setShowNewPromptDialog] = useState(false)
    const [editmode, setEditMode] = useState(false)

    const[preview, setPreview] = useState("")
    const[showPreviewDialog, setShowPreviewDialog] = useState(false)
    const[chatPrompt, setChatPrompt] = useState('')

    const [isDBChecked, setDBCheckBox] = useState(false)

    const[arrowLeft, setArrowLeft] = useState(false)
    const[arrowRight, setArrowRight] = useState(false)
    const[arrowSplit, setArrowSplit] = useState(true)
    
    const {
        currentUser, 
        checkCurrentUser,
        checkServerCode,
    } = React.useContext(AuthContext);

    const {
        setStatusNavbar,
        temperature,
        sortTemplates,
        mainLanguage,
        changeLanguage,
        setIsLoading,
        handleFocus,
        getAIProvider,
        getAIModel,
        getAIName,
        setWaitOnResponse,
    } = React.useContext(StatusContext);


    const {
       availablecredits,
       updateCredits
    } = React.useContext(ClientContext);

    
    useEffect(() => {
        console.log("Templates useEffect")

        setTemplateName('')
        
    }, [])

    const onEditMode = (prompt) =>
        {
         console.log("oneditMode")
         setEditMode(true)
         setNewPrompt(prompt)
         setShowNewPromptDialog(true)
        }

    const onAcceptDeleteResponse = (response) => {
        let a = allresponses.filter(item => item.id !== response.id)

        for ( let i = 0; i < a.length; ++i)
            a[i].id = i

        setAllResponses(a)
      
      }
      
      const onCancelDeleteResponse = (response) => {
        let a = [...allresponses]

        for ( let i = 0; i < a.length; i++)
        {
            if ( a[i].id === response.id)
            {
                a[i].delete = false;
                break
            }
        }
      
        setAllResponses(a)
      }
      
      const onDeleteResponse = (response) => {
    
        let a = [...allresponses]
 
        for ( let i = 0; i < a.length; i++)
        {
            if ( a[i].id === response.id)
            {
                a[i].delete = true;
                break
            }
        }
       
        setAllResponses(a)
      }


const  ScrollToBottom = () => {

    
    setTimeout(() => {
        if (promptareaRef.current) {
            const { offsetHeight, scrollHeight } = promptareaRef.current;
            const bottomPosition = (scrollHeight - offsetHeight)*2;
            promptareaRef.current.scrollTo({ top: bottomPosition, behavior: 'smooth' });
          }
        
      }, 100);

    }

    const displaySample = (sample) => {
        
        console.log("displaySample:", sample)
        if (sample === "Custom Email")
        {
            displayTemplate(emailproperty)
            setStatus(changeLanguage('status', 'exampletext20'))
        }
        if (sample === "Review")
        {
            if (mainLanguage === 'Serbian')
                displayTemplate(performancereview_Serbian)
            else  if (mainLanguage === 'Spanish')
                displayTemplate(performancereview_Spanish)
            else  if (mainLanguage === 'Portuguese')
                displayTemplate(performancereview_Portuguese)
            else  if (mainLanguage === 'French')
                displayTemplate(performancereview_French)
                else  if (mainLanguage === 'German')
                displayTemplate(performancereview_German)
            else
                displayTemplate(performancereview)
            setStatus(changeLanguage('status', 'exampletext21'))
        }

        if (sample === "Email")
        {
            if (mainLanguage === 'Serbian')
                displayTemplate(email_Serbian)
            else if (mainLanguage === 'Spanish')
                displayTemplate(email_Spanish)
            else if (mainLanguage === 'Portuguese')
                displayTemplate(email_Portuguese)
            else  if (mainLanguage === 'French')
                displayTemplate(email_French)
             else  if (mainLanguage === 'German')
                displayTemplate(email_German)
            else
                displayTemplate(email)
            setStatus(changeLanguage('status', 'exampletext22'))
        }

        if (sample === "Travel expense")
        {
            if (mainLanguage === 'Serbian')
                displayTemplate(travelexpense_Serbian)
            else if (mainLanguage === 'Spanish')
                displayTemplate(travelexpense_Spanish)
            else if (mainLanguage === 'Portuguese')
                displayTemplate(travelexpense_Portuguese)
            else  if (mainLanguage === 'French')
                displayTemplate(travelexpense_French)
                else  if (mainLanguage === 'German')
                displayTemplate(travelexpense_German)
            else
                displayTemplate(travelexpense)
            setStatus(changeLanguage('status', 'exampletext22'))
        }
        if (sample === "Inventory")
        {
            displayTemplate(inventory)
            setStatus(changeLanguage('status', 'exampletext22'))
        }
        if (sample === "Extraction")
        {
            displayTemplate(extraction)
            setStatus(changeLanguage('status', 'exampletext22'))
        }
        if (sample === "Problem Solving")
        {
            displayTemplate(problemsolving)
            setStatus(changeLanguage('status', 'exampletext22'))
        }
        if (sample === "Product Description")
        {
            displayTemplate(productdescription)
            setStatus(changeLanguage('status', 'exampletext22'))
        }

        if (sample === "...")
        {
            setStatus("Use Create prompt to create sequence of steps for a template. Devide your task into who, what, facts, description, to do, etc.")
        }

        if (sample === "Florida oranges")
        {
            if (mainLanguage === 'Serbian')
                displayTemplate(floridaoranges_Serbian)
            else  if (mainLanguage === 'Spanish')
                displayTemplate(floridaoranges_Spanish)
            else  if (mainLanguage === 'Portuguese')
                displayTemplate(floridaoranges_Portuguese)
            else  if (mainLanguage === 'French')
                displayTemplate(floridaoranges_French)
            else  if (mainLanguage === 'German')
                displayTemplate(floridaoranges_German)
            else
                displayTemplate(floridaoranges)
            setStatus(changeLanguage('status', 'exampletext23'))
        }
    }

    
    const onClearResponse = () => {
        console.log("onClearResponse")
        setAllResponses([])
        setPrompt('')
    }

    const onClearPrompts = () => {
        console.log("onClearPrompts")
        setPrompt('')
        setPrompts([])
        setTemplateName('')
        setPromptsAvailable(false)
        setStatus('')
       
    }

    const adjustTemplates = (filteredTemplates) => {
        let adjustedTemplates = []
        let i = 0;
        filteredTemplates.forEach((templ) => {
           let newtempl = templ;
           newtempl.id = i;
           adjustedTemplates.push(newtempl);
           i++
        })

        return adjustedTemplates;
    }


    const deleteTemplate = async (deletionTemplate) => {
        console.log("Delete Template")
        if (checkCurrentUser() === false)
        {
            setStatus(changeLanguage('status', 'pleaselogin'))
            return;
        }

        let newTemplates = [];

        setIsLoading(true)

        try{
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/customtemplates/get", {currentUser}) 
            newTemplates =JSON.parse(res.data[0].templates)  
        }
        catch(err)
        {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }

        let filteredTemplates = newTemplates.filter(template => template.id !== deletionTemplate.id)
        //adjust array indexes
        let adjustedTemplates = adjustTemplates(filteredTemplates)
  
        var customtemplates = JSON.stringify(adjustedTemplates)
        
        try {
            await axios.post(config.url.API_URL + "/deda_ai_api/customtemplates/save", { currentUser, customtemplates }, {
                withCredentials: true
            })
            setTemplates(adjustedTemplates);
        }
        catch (err) {
            setStatus(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false)
            return
        }

        //if (templateName === deletionTemplate.name) {
        //    onClearResponse()
        //}

        setIsLoading(false)
       
    }

    const displayTemplate = (displayedChat) => {
     
        onClearPrompts();
        if (displayedChat.response)
         setAllResponses([...displayedChat.response])
        else
         setAllResponses([])
        ////console.log(displayedChat)
        setPrompts(displayedChat.prompts)
        console.log("Template name:", displayedChat.name)
        
        setTemplateName(displayedChat.name)
        setShowAddPrompt(false);
        setPromptsAvailable(true);
      
    }

    //Preview
    const onPreview = () => {
        setPreview(formatPrompt())
        setShowPreviewDialog(true)
    }

    const onSave = async () => {
       
        if (checkCurrentUser() === false)
        {
            setStatusNavbar(changeLanguage('status', 'pleaselogin'))
            return;
        }

        if (templateName.length === 0) {
            setStatusNavbar(changeLanguage('status', 'namenotdefined'))
            return
        }

        let newTemplates = [];
        let customtemplates = [];

        setIsLoading(true);

        let q = "/deda_ai_api/customtemplates/get"
        try {
            const res = await axios.post(config.url.API_URL + q, {currentUser}) 

            if (res.data.length > 0) {
                //Templates already exists
             
                let templates = JSON.parse(res.data[0].templates)
                console.log('Templates exists:', templates)

                //when all templates are deleted array saved in DB is empty and we check that case
                if (templates.length === 0)
                {
                    let newTemplate = {
                        id: 0,
                        name: templateName,
                        prompts: prompts,
                        response: allresponses,
                    };

                    newTemplates.push(newTemplate)
                    customtemplates = JSON.stringify(newTemplates)
                    console.log("CustomTemplates 1:", customtemplates)

                }
                else
                {
                    newTemplates = JSON.parse(res.data[0].templates)

                    const template = newTemplates.find(p => p.name === templateName);
                    if ( template)
                    {
                        //Update
                        let result = window.confirm(changeLanguage('tutor', 'sametopic'));
                        if (!result)
                            return;

                        template.prompts = prompts;
                        template.response = allresponses;
                        customtemplates = JSON.stringify(newTemplates)
                    }
                    else
                    {
                        //Add
                        let newTemplate = {
                            id: newTemplates.length,
                            name: templateName,
                            prompts: prompts,
                            response: allresponses,
                        };
                        newTemplates.push(newTemplate)
                        let sortedTemplates = sortTemplates(newTemplates)
                        let adjustedTemplates = adjustTemplates(sortedTemplates)
                        customtemplates = JSON.stringify(adjustedTemplates)
                        newTemplates = [...adjustedTemplates]
                    }
                }
            }
            else
            {
                // Handle case when res.data is empty
                //New user does not have any data and there are no saved templates.
                
                    let newTemplate = {
                        id: 0,
                        name: templateName,
                        prompts: prompts,
                        response: allresponses,
                 };
                newTemplates.push(newTemplate);
             
                customtemplates = JSON.stringify(newTemplates)
                
            }

            try {
                const res = await axios.post(config.url.API_URL + "/deda_ai_api/customtemplates/save", { currentUser, customtemplates }, {
                withCredentials: true
                })

                setTemplates(newTemplates)
                setIsLoading(false);
                return res;
            }
            catch (err) {
                setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
                setIsLoading(false);
                return
            }
            
        } catch (err) {
            console.log("Received error 1:", err)
            setStatusNavbar(`Error: ${checkServerCode(err.code)}`)
            setIsLoading(false);
        }
        
        setIsLoading(false)
        
    }
    const formatPrompt = () => {
        let req = ''
        const regex = /^(?!.*[.;:?!]$).*$/;
        for (let i = 0; i < prompts.length; i++) {
            let who = prompts[i].who
            let what = prompts[i].what
            who.trim()
            what.trim()

            if (who.length && regex.test(who)) {
                who += ":"
            }
            if (what.length && regex.test(what)) {
                what += "."
            }
            req += who + '\n\n' + what + '\n\n';
            

        }

        //req += 'Please provide an answer from the above context to the following query: ' + chatPrompt
        req += chatPrompt

        return req;


    }
    const onSubmit = () => {

        let req = formatPrompt()

        if (req.length === 0) {
            return
        }
     
    
        if (isDBChecked)
            sendRequest_DB(req)
        else
            SendRequest(req)

        //handleFocus()
    }

    const sendRequest_DB = async (request) => {
        setStatus('')
        if ( availablecredits <= 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }

        let text = ''

        let req = {
            request: request,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

         if (arrowLeft)
            setArrowSplit(true)

      
        setIsLoading(true);

        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })

            let server_response = JSON.parse(res.data);
            console.log("Server response:", server_response.data)

            //extract SQL statement
            if (server_response.data.includes('??')) {
                console.log("String contains '??'");
                text = 'We are not able to provide an answer. Please change the query and try again.'
              
              
                updateCredits(server_response.tokens)
                setStatus(text)
                setIsLoading(false)
                return
            }
          
        
                //const regex = /@@(.*?)@@/g;
                const regex = /@@([\s\S]*?)@@/g;
                let matches = [];
                let match;

                while ((match = regex.exec(server_response.data)) !== null) {
                    matches.push(match[1]); // match[1] is the captured group (text inside @@)
                }

                console.log("Matches: ", matches)
            if (matches.length === 0)
            {
                text = 'Invalid query - We are not able to provide an answer. Please change the query and try again.'
                updateCredits(server_response.tokens)
                setStatus(text)
                setIsLoading(false)
                return
            }
            
            console.log("SQL:", matches[0])

            //For each SQL get data and concatinate them

            let sql = matches[0]


            try{
                let q = "/deda_ai_api/customtemplates/getdata"
                const res = await axios.post(config.url.API_URL + q, {currentUser, sql}) 
                console.log("ResData:", res.data)

                text = JSON.stringify(res.data)
                
                updateCredits(server_response.tokens)
                
            } 
            catch(err)
            {
                setIsLoading(false);
                console.log("getData-error:", err.response.data)       
                //setStatus(`Error: ${checkServerCode(err.response.data)}`)
            }
            
        } catch (err) {
            console.log("Error:", err)
            setStatus(`Error: ${checkServerCode(err.response.data)}`)
        }
        

      let s = `Provide response as a user friendly text to answer the query: ${chatPrompt} .The response is: ${text} `;
        req = {
            request: s,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }

         if (allresponses.length > 0)
        {
            setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
            handleFocus()
        }

        setIsLoading(true);

        console.log("Text:", s)

        if (text.length)
        {

            try {
                const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                    withCredentials: true
                })

                let server_response = JSON.parse(res.data);

                let i = 0
                if (allresponses.length)
                {
                    i = allresponses[allresponses.length-1].id + 1
                }
                let r = {
                    id:  i,
                    delete: false,
                    prompt: "Response:",
                    response: server_response.data,
                    aiprovider: getAIProvider(),
                    aimodel: getAIModel(),
                    ainame: getAIName(),
                }

                setAllResponses([...allresponses, r])
        
                updateCredits(server_response.tokens)
            }
            catch (err) {
                console.log("Error:", err)
                setStatus(`Error: ${checkServerCode(err.response.data)}`)
            }
        }

        setWaitOnResponse('')  
        handleFocus()
        setIsLoading(false)
      
    }

    const SendRequest = async (request) => {
        setStatus('')
        if ( availablecredits <= 0 )
        {
            setStatus(changeLanguage('status', 'addcredits'))
            return;
        }

        if (allresponses.length > 0)
        {
            setWaitOnResponse(changeLanguage('aitest', 'waitonresponse'))
            handleFocus()
        }

        let req = {
            request: request,
            temperature: temperature,
            aiprovider: getAIProvider(),
            aimodel: getAIModel(),
            ainame: getAIName(),
        }
    
        setIsLoading(true);

        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/openai/request", { req }, {
                withCredentials: true
            })

            let server_response = JSON.parse(res.data);

            let i = 0
            if (allresponses.length)
            {
                i = allresponses[allresponses.length-1].id + 1
            }
            let r = {
                id:  i,
                delete: false,
                prompt: "Response:",
                response: server_response.data,
                aiprovider: getAIProvider(),
                aimodel: getAIModel(),
                ainame: getAIName(),
            }

            setAllResponses([...allresponses, r])
           
            setPrompt('')
            if (arrowLeft)
                setArrowSplit(true)
            updateCredits(server_response.tokens)

        } catch (err) {
            console.log("Error:", err)
            setStatus(`Error: ${checkServerCode(err.response.data)}`)
        }

        setWaitOnResponse('')  
        handleFocus()
        setIsLoading(false)
        //ScrollResponse()

    }

    //Add Prompt
    const addPrompt = (prompt) => {
        var id = 1;
        if (prompts.length > 0) {
            id = prompts[prompts.length - 1].id + 1;
           
        }

        //console.log("addPrompt : New id:", id)
        prompt.id = id

       
        //console.log("addPrompt : newPrompt", prompt)
        setPrompts([...prompts, prompt])
        setPromptsAvailable(true);

        ScrollToBottom();

    }

    const updatePrompt = (prompt) => {
        console.log("updatePrompt : prompts", prompts)
        console.log("updatePrompt : prompt", prompt)

        
        const newPrompts = [...prompts]
        newPrompts[prompt.id-1] = prompt

        setPrompts(newPrompts)

   
        setPromptsAvailable(true);

     

    }

    //Delete prompt
    const deletePrompt = (id, e) => {
        //check for last prompt.
        //we cannot check for 0 because of rendering
        if (prompts.length === 1)
            setPromptsAvailable(false);

        let newprompts = prompts.filter((prompt) => prompt.id !== id)
        newprompts = [...prompts]
        newprompts = newprompts.filter((prompt) => prompt.id !== id)
    
        //adjust ids
        if (newprompts.length > 1)
        {
            for (let i = 1; i <= newprompts.length; i++)
            {
                newprompts[i-1].id = i;
            }
        }

        setPrompts([...newprompts])
    }

    //Change who
    const changeWho = (id, e) => {
        var s = e.target.value;
        e.target.style.height = 'auto';
        e.target.style.height = `${e.target.scrollHeight}px`;
        const newPrompts = prompts.map(prompt => {
            if (prompt.id === id) {
                return { ...prompt, who: s }
            }
            return prompt
        })

        setPrompts(newPrompts)
    }

       
    //Change prompt
    const changePrompt = (id, e) => {
        var s = e.target.value;
        e.target.style.height = 'auto';
        e.target.style.height = `${e.target.scrollHeight}px`;
        const newPrompts = prompts.map(prompt => {
            if (prompt.id === id) {
                return { ...prompt, what: s }
            }
            return prompt
        })

        setPrompts(newPrompts)

       
    }

    const onClickedPrompt = () => {
        console.log("onClickedPrompt")
       
    }

    //Move prompt
    const moveupPrompt = (id, e) => {
        console.log('moveupPrompt:', id)

        var index = prompts.findIndex((obj => obj.id === id))
        console.log("index: ", index)

        if (index > 0) {
            const newprompts = [...prompts]

            newprompts.splice(index - 1, 0, newprompts.splice(index, 1).pop());
            //console.log("MOVE UP Before newprompts:", newprompts)

           //adjust ids
            if (newprompts.length > 1)
            {
                for (let i = 1; i <= newprompts.length; i++)
                {
                    newprompts[i-1].id = i;
                }

                //console.log("MOVE UP Aftere newprompts:", newprompts)
            }
        
            
            setPrompts([...newprompts])
        }
    }

    //Move dowwn
    const movedownPrompt = (id, e) => {

        var index = prompts.findIndex((obj => obj.id === id))
        if (index < prompts.length - 1) {
            const newprompts = [...prompts]
            newprompts.splice(index + 1, 0, newprompts.splice(index, 1).pop());
            //console.log("MOVE Down Before newprompts:", newprompts)
            //adjust ids
            if (newprompts.length > 1)
            {
                for (let i = 1; i <= newprompts.length; i++)
                {
                    newprompts[i-1].id = i;
                }
            }
            //console.log("Move down Aftere newprompts:", newprompts)
            setPrompts(newprompts)
        }
    }

    //edit prompt
    const editPrompt = (id, e) => {
        console.log("editPrompt: ", id)
        setPromptEdit(!promptedit)
        return;
    }

    const getTemplates = async () => {

        let sortedTemplates  = []
        setIsLoading(true)
        
        try {
            const res = await axios.post(config.url.API_URL + "/deda_ai_api/customtemplates/get", { currentUser })

            if (res.data.length > 0)
            {
                let templates = JSON.parse(res.data[0].templates)
                if (templates != null) {
                    sortedTemplates = sortTemplates(templates)
                    setTemplates(sortedTemplates)
                }
            }
            else
            {
                  // Handle case when res.data is empty
                console.log("No data in res.data")

            }
        }
        catch (err) {
            console.log("Received error:", err)
            setStatus(`Error: ${checkServerCode(err.code)}`)
        }
        setIsLoading(false)

        let chatsstatus = {chats: sortedTemplates, status: 200}

        return chatsstatus

    }

    return <CustomTemplatesContext.Provider value={{
        onClearResponse,
        chatNames,
        setChatNames,
        chatName,
        setChatName,
        onSave,
        displayTemplate,
        deleteTemplate,
        templates,
        setTemplates,
        templateName,
        setTemplateName,
        onClearPrompts,
        samples,
        setSamples,
        onSubmit,
        onPreview,
        //response,
        addPrompt,
        deletePrompt,
        changePrompt,
        moveupPrompt,
        movedownPrompt,
        prompts,
        setPrompts,
        prompt,
        setPrompt,
        editPrompt,
        promptedit,
        displaySample,
        status,
        getTemplates,
        showAddPrompt,
        setShowAddPrompt,
        setPromptsAvailable,
        promptsAvailable,
        onClickedPrompt,

       
        promptareaRef,
        allresponses,
        onAcceptDeleteResponse,
        onCancelDeleteResponse,
        onDeleteResponse,
        changeWho,
        newPrompt,
        setNewPrompt,
        showNewPromptDialog,
        setShowNewPromptDialog,

        editmode,
        setEditMode,
        onEditMode,
        updatePrompt,

        preview, 
        showPreviewDialog, 
        setShowPreviewDialog,

        chatPrompt, 
        setChatPrompt,

        isDBChecked, 
        setDBCheckBox,
        arrowLeft, 
        setArrowLeft,
        arrowRight,
        setArrowRight,
        arrowSplit,
        setArrowSplit
    
    }}>
        {props.children}
    </CustomTemplatesContext.Provider>
})